module.exports = "<electra-map [ngClass]=\"menuClass\"></electra-map>\n<electra-menu-wrapper [ngClass]=\"menuClass + ' ' + menuState\"></electra-menu-wrapper>\n<electra-header-wrapper></electra-header-wrapper>\n<electra-splash></electra-splash>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/electraLib/component/electra/electra.component.html
// module id = 421
// module chunks = 1